import { GroupedBadges } from '@components/database/groupedBadges';
import { useRowReferences } from '@hooks/useRowReferences';
import type {
  AtomReference,
  RowData,
  RowReference
} from '@stratumn/studio-shared';
import type { CustomCellRendererProps } from 'ag-grid-react';

import type { SelectorOption } from '../customEditors/multi-select.editor';

export const BadgeRenderer = (
  params: CustomCellRendererProps<
    RowData,
    AtomReference[] | string[] | undefined
  >
) => {
  const finalSelectedOptions: SelectorOption[] = [];
  const rowReferences: RowReference[] = useRowReferences(
    params.value?.every(val => typeof val !== 'string') ? params.value : []
  );

  if (params.value?.every(val => typeof val !== 'string')) {
    finalSelectedOptions.push(
      ...rowReferences.map(rowRef => ({
        label: rowRef.displayedValue,
        value: rowRef.dataItemId
      }))
    );
  }

  if (params.value?.every(val => typeof val === 'string')) {
    finalSelectedOptions.push(
      ...params.value.map(val => ({
        label: val,
        value: val
      }))
    );
  }

  return <GroupedBadges selectedOptions={finalSelectedOptions} />;
};
